/**
 * Filters component
 * 
 * @module component-filters
 * @version 1.0.0 
 * @extends HTMLElement
 */

 customElements.component = 'component-filters';

 if (!customElements.get(customElements.component)) {
 
    class ComponentFilters extends HTMLElement {

     /**
     * Filters web component
     * 
     * @constructor
     */
    constructor() {

        super();

        this.closeFilter();
        this.initFocusTrap();
        this.initEvents();
    }

    /**
     * Init Events
     * 
     * @returns {undefined}
     */
    initEvents() {

        // Open button
        document.querySelectorAll('[data-button-filter]').forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                this.openFilter();
            });
        });


        // Close button
        document.querySelectorAll('[data-filter-close]').forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                this.closeFilter();
            });
        });

        // Close on window resize
        window.addEventListener('screen-breakpoint', event => {
            this.closeFilter();
        });

        // Close filters on press escape
        window.addEventListener('escape', event => {
            this.closeFilter();
        });

        // Check the option on enter key press
        document.querySelectorAll('[data-filter-input-option], [data-filter-checkbox-option]').forEach(element => {
            element.addEventListener('keypress', event => {
                event = event || window.event;
                let key = event.key || event.keyCode;
                if (key === 'Enter' || key === 13) {                    
                    element.checked = !element.checked;
                }
            });
        });

        // Selection control for list items
        document.querySelectorAll('[data-filter-list-option-link]').forEach(element => {
            element.addEventListener('click', event => {
                let group = element.parentNode.parentNode.dataset.filterGroup;
                let items = document.querySelectorAll('[data-filter-group="' + group +'"] li');

                items.forEach( item => {
                    item.classList.remove('selected');
                });

                element.parentNode.classList.add('selected');
            });
        });

    }

    /**
     * Open filter
     * 
     * @returns {undefined}
     */
    openFilter() {

        this.classList.remove('hidden');

        document.querySelector('[data-filter-overlay]').classList.remove('hidden');

        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');

        this.setAttribute('aria-hidden', 'false');

        // We need to use set time out to avoid issues with filter animation
        setTimeout(() => {
            this.classList.add('active');
            this.querySelector('[data-filter-close]').focus({ preventScroll: true });
            this.activeFocusTrap();
        }, 50);
        
    }

    /**
     * Close filter
     * 
     * @returns {undefined}
     */
    closeFilter() {

        this.classList.remove("active");

        this.setAttribute('aria-hidden', 'true');

        this.disableFocusTrap();
		
		// We need to use set time out to avoid issues with filter animation
        setTimeout(() => {
            this.classList.add('hidden');
            document.querySelector('[data-filter-overlay]').classList.add('hidden');
            document.documentElement.classList.remove('overflow-hidden');
            document.body.classList.remove('overflow-hidden');
        }, 50);

    }

    /**
     * Init Focus Trap
     * 
     * @returns {undefined}
     */
    initFocusTrap() {

        this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true, preventScroll: true });
    }

    /**
     * Disable Focus Trap
     * 
     * @returns {undefined}
     */
    disableFocusTrap() {

        if (this.focusTrap) {
            this.focusTrap.deactivate();
        }
    }

    /**
     * Active Focus Trap
     * 
     * @returns {undefined}
     */
    activeFocusTrap() {

        if (this.focusTrap) {
            this.focusTrap.activate();
        }
    }

}

customElements.define(customElements.component, ComponentFilters);
}
